import { render, staticRenderFns } from "./EditJspmPrinter.vue?vue&type=template&id=50f15fb7&"
import script from "./EditJspmPrinter.vue?vue&type=script&lang=js&"
export * from "./EditJspmPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports